<template>
	<div class="module">
		<ul class="flex-column" :style="{'animation-duration': `${dataList.length * 1.2}s`}">
			<li v-for="(item, i) in dataList" :key="i" class="flex-center">
				<img v-if="i < 3" :src="require(`@/assets/image/digital/badge_${i + 1}.png`)">
				<ins v-else class="flex-center">{{i + 1}}</ins>
				<p class="flex-grow">{{item.nick_name}}</p>
				<span>￥{{item.money}}</span>
			</li>
			<li v-for="(item, i) in dataList" :key="`r${i}`" class="flex-center">
				<img v-if="i < 3" :src="require(`@/assets/image/digital/badge_${i + 1}.png`)">
				<ins v-else class="flex-center">{{i + 1}}</ins>
				<p class="flex-grow">{{item.nick_name}}</p>
				<span>￥{{item.money}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dataList: []
			}
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/award/ranking',
					success: data => {
						this.dataList = data;
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.module {
		overflow: hidden;
		
		ul {
			animation: listScroll 5s linear infinite;
			
			li {
				height: .4rem;
				padding: 0 .2rem;
				font-size: .14rem;
				white-space: nowrap;
				color: #ABFFE9;
				
				img {
					width: .22rem;
				}
				
				ins {
					box-sizing: border-box;
					width: .22rem;
					height: .22rem;
					border: 1px solid #3E6452;
					border-radius: 50%;
					font-size: .12rem;
				}
				
				p {
					margin: 0 .14rem;
				}
			}
		}
	}

	@keyframes listScroll {
		0% {
			transform: translate(0,0);
		}

		100% {
			transform: translate(0,-50%);
		}
	}
</style>